import React from 'react';
import { batch } from 'react-redux';
import { addIndication, INDICATION_TYPES } from 'modules/taboola-common-frontend-modules/Indications';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import landingPagesApi from 'services/api/landingPagesApi';
import { errorMessagesUtils } from 'services/utils';
import {
    requestUpdateLandingPage,
    updateLandingPageError,
    updateLandingPageSuccess,
} from '../actions/updateLandingPage';

export const successIndication = {
    type: INDICATION_TYPES.SUCCESS,
    message: <FormattedMessage id="landing.pages.edit.success" defaultMessage="Advertorial updated successfully" />,
    highlight: <FormattedMessage id="success.highlight" defaultMessage="Success!" />,
};

export const generateErrorIndication = (errorObject = {}) => ({
    type: INDICATION_TYPES.ERROR,
    message: errorMessagesUtils.getErrorMessage(errorObject),
    highlight: <FormattedMessage id="landing.pages.edit.error.highlight" defaultMessage="Unable to save changes." />,
});

export const updateLandingPage = landingPage => async dispatch => {
    dispatch(requestUpdateLandingPage());

    try {
        const updatedLandingPage = await landingPagesApi.editLandingPage(landingPage);

        batch(() => {
            dispatch(updateLandingPageSuccess(updatedLandingPage));
            dispatch(addIndication(successIndication));
        });

        return updatedLandingPage;
    } catch (error) {
        dispatch(addIndication(generateErrorIndication(error)));
        dispatch(updateLandingPageError({ id: landingPage.id, error }));
        throw error;
    }
};
